import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import EyeIcon from '@wix/da-ds/pkg/Icons/Eye';
import UnwatchIcon from '@wix/da-ds/pkg/Icons/Unwatch';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { canPeek } from '../../utils';
import { CommentContext } from '../../CommentContext';
import CommentDataAttrDiv from '../../lego/CommentDataAttrDiv';
import s from './HiddenView.scss';

interface Props {}

const HiddenView: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { setPeeking, comment } = useContext(CommentContext);

  return (
    <CommentDataAttrDiv className={s['root']}>
      {canPeek(comment) && (
        <PlainButtonOrLink
          className={c(s['hidden'], s['peekable'])}
          onClick={() => setPeeking(true)}
        >
          <span className={s['hidden-text']}>
            <UnwatchIcon className={s['hidden-icon']} />
            {t('comment.visibility.hidden')}
          </span>
          <span className={s['hidden-text-hover']}>
            <EyeIcon className={s['hidden-icon']} />
            {t('comment.visibility.hidden.showComment')}
          </span>
        </PlainButtonOrLink>
      )}
      {!canPeek(comment) && (
        <div className={s['hidden']}>
          <span className={s['hidden-text']}>
            <UnwatchIcon className={s['hidden-icon']} />
            {t('comment.visibility.hidden')}
          </span>
        </div>
      )}
    </CommentDataAttrDiv>
  );
};
HiddenView.displayName = 'HiddenView';

export default HiddenView;
